import React from "react"
import { Col, Row, Form, Dropdown } from "react-bootstrap"
import { getIn } from "formik"
import FormLabel from "./formLabel"

function FormDropdownArray(props) {
  const {
    textDesc,
    form,
    field,
    dropdownItem,
    propertyName,
    secondFieldName,
    secondPropertyName,
  } = props

  const errorsMsg = getIn(form.errors, field.name)
  // const touched = getIn(form.touched, field.name)

  const inputErrorMessage = (touched, errors, inputName) => {
    return errors[inputName] && touched[inputName] ? (
      <span className="InputError">{errorsMsg}</span>
    ) : null
  }

  const DropdownValueChange = (newValue, secondFieldNewValue) => {
    form.setFieldValue(field.name, newValue)
    if (secondFieldName && secondFieldNewValue) {
      form.setFieldValue(secondFieldName, secondFieldNewValue)
    } else if (secondFieldName && !secondFieldNewValue) {
      form.setFieldValue(secondFieldName, "")
    }

    // if (extraFieldValue && affectedField) {
    //   if (extraFieldValue.indexOf(description) !== -1) {
    //     denied = true
    //   }

    //   affectedField.forEach((FieldItem, FieldKey) => {
    //     delete errorsList[FieldItem]
    //     actionList.push(
    //       updateCategoryClaimData(coverageCategory, coverageCode, FieldItem, "")
    //     )
    //     form.setFieldValue(FieldItem, "")
    //   })
    // }
  }

  return (
    <Form.Group>
      <Row>
        <FormLabel text={textDesc} />
        <Col xs={12} md={6} className="marginTop10px">
          <Dropdown className="dropdown">
            <Dropdown.Toggle className="btn btn-secondary dropdown-toggle DropdownHeader">
              {field.value}
              {/* {dropDownValue} */}
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu DropdownMenu">
              {dropdownItem.map((item, key) => (
                <Dropdown.Item
                  key={key}
                  onClick={() => {
                    DropdownValueChange(
                      item[propertyName],
                      item[secondPropertyName]
                    )
                  }}
                >
                  {item[propertyName]}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
          {/* {errors && touched && <span className="InputError">{errors}</span>} */}
          {/* <span className="InputError">{errors}</span> */}
          {inputErrorMessage(form.touched, form.errors, field.name)}
        </Col>
      </Row>
    </Form.Group>
  )
}

export default FormDropdownArray
